// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3smq2","imageUploader":"EGiftCard_imageUploader__2U2lW"};